(function(){
  var GALLERIES={
    jug5:[
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/CopyofShopifyProductImages_1.png?v=1783906123',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/SingleJug-Copy.jpg?v=1783045754',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/Clore_test_logoBR_1.png?v=1778699947'
    ],
    kit10:[
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/10.jpg?v=1786663592',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/Live_Action_Spraying_86017363-5135-468f-9a8b-6505b63595d3.jpg?v=1786740181',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/1_jug_in_front_of_door.png?v=1787510610',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/Product_Images_Shopify_811.jpg?v=1786663806',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/ChatGPT_Image_Aug_23_2026_03_35_07_PM.png?v=1787510127',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/Clore_test_logoBR_1.png?v=1778699947',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/EE2E232D-0D16-4C4F-9B54-6FEBD42B5DA2_1_105_c_6f6f73cb-bfb7-43ab-939b-bc137e9e0d77.jpg?v=1778777165'
    ],
    kit20:[
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/11.jpg?v=1786663592',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/Live_Action_Spraying_86017363-5135-468f-9a8b-6505b63595d3.jpg?v=1786740181',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/2_jugs_in_front_of_door.png?v=1787510610',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/Product_Images_Shopify_811.jpg?v=1786663806',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/ChatGPT_Image_Aug_23_2026_03_35_07_PM.png?v=1787510127',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/Clore_test_logoBR_1.png?v=1778699947',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/EE2E232D-0D16-4C4F-9B54-6FEBD42B5DA2_1_105_c_6f6f73cb-bfb7-43ab-939b-bc137e9e0d77.jpg?v=1778777165'
    ],
    kit30:[
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/12.jpg?v=1786663592',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/Live_Action_Spraying_86017363-5135-468f-9a8b-6505b63595d3.jpg?v=1786740181',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/3_jugs_in_front_of_door.png?v=1787510610',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/Product_Images_Shopify_811.jpg?v=1786663806',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/ChatGPT_Image_Aug_23_2026_03_35_07_PM.png?v=1787510127',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/Clore_test_logoBR_1.png?v=1778699947',
      'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/EE2E232D-0D16-4C4F-9B54-6FEBD42B5DA2_1_105_c_6f6f73cb-bfb7-43ab-939b-bc137e9e0d77.jpg?v=1778777165'
    ]
  };

  function preserveScroll(action){
    var root=document.getElementById('clore-ember-kit-quiz'),top=root?root.scrollTop:0;
    action();
    if(root){
      root.scrollTop=top;
      requestAnimationFrame(function(){root.scrollTop=top;});
    }
  }

  function saveResultState(patch){
    try{
      var saved=JSON.parse(localStorage.getItem('cloreKitQuizState')||'{}');
      Object.keys(patch).forEach(function(key){saved[key]=patch[key];});
      saved.updatedAt=Date.now();
      localStorage.setItem('cloreKitQuizState',JSON.stringify(saved));
    }catch(e){}
  }

  function alignDefendHeroHeadline(){
    var heading=document.querySelector('#clore-lovable-port.clore-defend-only .clore-ember-hero h1');
    var verification=document.querySelector('#clore-lovable-port.clore-defend-only .clore-ember-hero ul li p:last-child');
    if(!heading&&!verification)return;
    var properties=['width','max-width','margin-left','margin-right','align-self','text-align'];
    if(window.matchMedia('(min-width: 1024px)').matches){
      if(heading){
        heading.style.setProperty('width','max-content','important');
        heading.style.setProperty('max-width','none','important');
        heading.style.setProperty('margin-left','0','important');
        heading.style.setProperty('margin-right','0','important');
        heading.style.setProperty('align-self','center','important');
        heading.style.setProperty('text-align','center','important');
      }
      if(verification){
        verification.style.setProperty('font-size','11.43px','important');
        verification.style.setProperty('line-height','1.25','important');
      }
    }else{
      if(heading)properties.forEach(function(property){heading.style.removeProperty(property);});
      if(verification){
        verification.style.removeProperty('font-size');
        verification.style.removeProperty('line-height');
      }
    }
  }

  function textHeading(stage,text){
    return Array.from(stage.querySelectorAll('h3')).find(function(heading){return heading.textContent.trim()===text;});
  }

  function enhance(){
    var stage=document.querySelector('#clore-ember-kit-quiz [data-clore-kit-quiz-stage]');
    if(!stage||!stage.querySelector('h1')||stage.querySelector('h1').textContent.indexOf('Based on Your Answers')<0)return;
    var grid=stage.querySelector('.grid.gap-5');
    if(!grid)return;

    var oldTreatmentHeading=textHeading(stage,"Customized treatment for your home's vulnerabilities");
    var treatmentHeading=oldTreatmentHeading||textHeading(stage,'We identified these vulnerabilities to wildfires')||textHeading(stage,'Your wildfire vulnerabilities');
    var treatmentCard=treatmentHeading&&treatmentHeading.closest('.clore-quiz-card');
    if(treatmentHeading&&treatmentHeading.textContent.trim()!=='Your wildfire vulnerabilities')treatmentHeading.textContent='Your wildfire vulnerabilities';
    if(treatmentCard){
      treatmentCard.classList.remove('order-2','md:order-none');
      treatmentCard.classList.add('order-1','md:col-span-2');
      treatmentCard.style.order='-1';
      treatmentCard.style.gridColumn='1 / -1';
      if(grid.firstElementChild!==treatmentCard)grid.insertBefore(treatmentCard,grid.firstElementChild);
    }

    var galleryButton=stage.querySelector('[data-img-prev]');
    var kitCard=galleryButton&&galleryButton.closest('.clore-quiz-card');
    if(kitCard){
      kitCard.classList.remove('order-1');
      kitCard.classList.add('order-2');
      var inner=kitCard.querySelector('.clore-quiz-card__inner');
      if(inner&&!inner.querySelector('[data-clore-defense-card-header]')){
        var header=document.createElement('div');
        header.className='text-center mb-4';
        header.setAttribute('data-clore-defense-card-header','true');
        header.innerHTML='<span class="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-md bg-deep-forest/10"><svg class="h-4 w-4 text-accent" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 13c0 5-3.5 7.5-8 9-4.5-1.5-8-4-8-9V5l8-3 8 3v8Z"></path><path d="m9 12 2 2 4-4"></path></svg></span><h3 class="font-heading font-extrabold text-deep-forest text-lg">Customized defense for your home</h3>';
        inner.insertBefore(header,inner.firstChild);
      }
    }

    var kitTitle=kitCard&&Array.from(kitCard.querySelectorAll('h3')).find(function(heading){return /5 Gallon Clore Ready to Use Jug/.test(heading.textContent);});
    if(kitTitle){
      var includesHeading=textHeading(stage,'Includes everything you need');
      var includesCard=includesHeading&&includesHeading.closest('.clore-quiz-card');
      if(includesCard)includesCard.querySelectorAll('a').forEach(function(link){if(link.textContent.trim()==='Sprayer Manual PDF')link.remove();});
    }
    var productTitle=kitCard&&Array.from(kitCard.querySelectorAll('h3')).find(function(heading){return /Gallon/.test(heading.textContent);});
    if(productTitle&&!kitCard.querySelector('[data-clore-storage-description]')){
      var storage=document.createElement('p');
      storage.className='mt-1 text-sm text-muted-foreground';
      storage.setAttribute('data-clore-storage-description','true');
      storage.textContent='Stores at least 4 years.';
      productTitle.insertAdjacentElement('afterend',storage);
    }
    var giftTitle=stage.querySelector('.clore-quiz-gift-copy');
    if(giftTitle&&giftTitle.textContent.indexOf('FREE Member Gift')>=0)giftTitle.textContent=giftTitle.textContent.replace('FREE Member Gift','FREE Subscriber Gift');
    var textWalker=document.createTreeWalker(stage,NodeFilter.SHOW_TEXT);
    var textNodes=[];
    while(textWalker.nextNode())textNodes.push(textWalker.currentNode);
    textNodes.forEach(function(node){
      if(node.nodeValue.indexOf('1 x lithium ion battery backpack sprayer')>=0){
        node.nodeValue=node.nodeValue.replace('1 x lithium ion battery backpack sprayer','1 x 3.2 gallon lithium ion battery backpack sprayer');
      }
    });
    stage.querySelectorAll('.clore-quiz-details summary').forEach(function(summary){
      Array.from(summary.childNodes).forEach(function(node){
        if(node.nodeType===3&&node.nodeValue.indexOf('Why These Surfaces Are Treated')>=0)node.nodeValue=node.nodeValue.replace('Why These Surfaces Are Treated','Why These Surfaces Are Sprayed');
      });
    });
    stage.querySelectorAll('.clore-quiz-details-body p').forEach(function(paragraph){
      if(paragraph.textContent.indexOf('Areas beyond 50 feet may still pose a risk but are a lower treatment priority.')>=0){
        paragraph.innerHTML=paragraph.innerHTML.replace('Areas beyond 50 feet may still pose a risk but are a lower treatment priority.','Areas beyond 50 feet may still pose a risk but are a lower protection priority, as per Cal Fire');
      }
    });
    enhanceGallery(stage,kitCard);
    enhanceDelivery(stage);
    enhanceRecommendationPurchaseOptions(stage,kitCard);
  }

  function enhanceGallery(stage,kitCard){
    if(!kitCard||kitCard.getAttribute('data-clore-frictionless-gallery')==='true')return;
    var main=kitCard.querySelector('img[alt$="product photo"]'),prev=kitCard.querySelector('[data-img-prev]'),next=kitCard.querySelector('[data-img-next]'),dots=Array.from(kitCard.querySelectorAll('[data-img-dot]'));
    var productHeading=Array.from(kitCard.querySelectorAll('h3')).find(function(heading){return /Gallon/.test(heading.textContent);});
    if(!main||!prev||!next||!productHeading)return;
    var title=productHeading.textContent.trim(),key=/^5 Gallon/.test(title)?'jug5':(/^10 Gallon/.test(title)?'kit10':(/^20 Gallon/.test(title)?'kit20':'kit30'));
    var images=GALLERIES[key]||[],clean=function(url){return String(url||'').split('?')[0]},idx=Math.max(0,images.map(clean).indexOf(clean(main.currentSrc||main.src)));
    if(!images.length)return;
    kitCard.setAttribute('data-clore-frictionless-gallery','true');
    images.forEach(function(src){var preload=new Image();preload.src=src;});
    function show(nextIndex){
      preserveScroll(function(){
        idx=(nextIndex+images.length)%images.length;
        main.src=images[idx];
        dots.forEach(function(dot,i){dot.className='h-1.5 rounded-full transition-all '+(i===idx?'w-4 bg-accent':'w-1.5 bg-silver-sage');dot.setAttribute('aria-current',i===idx?'true':'false');});
        saveResultState({imgIdx:idx});
      });
    }
    function replaceButton(button,attribute,handler){
      var clone=button.cloneNode(true);
      clone.removeAttribute(attribute);
      clone.setAttribute('data-clore-frictionless-control','true');
      button.replaceWith(clone);
      clone.addEventListener('click',function(event){event.preventDefault();event.stopPropagation();handler();clone.blur();});
      return clone;
    }
    replaceButton(prev,'data-img-prev',function(){show(idx-1);});
    replaceButton(next,'data-img-next',function(){show(idx+1);});
    dots=dots.map(function(dot,i){
      var clone=dot.cloneNode(true);
      clone.removeAttribute('data-img-dot');
      clone.setAttribute('data-clore-frictionless-dot',String(i));
      dot.replaceWith(clone);
      clone.addEventListener('click',function(event){event.preventDefault();event.stopPropagation();show(i);clone.blur();});
      return clone;
    });
  }

  function enhanceDelivery(stage){
    var card=stage.querySelector('.clore-quiz-subscription-card');
    if(!card||card.getAttribute('data-clore-frictionless-delivery')==='true')return;
    var oldToggle=card.querySelector('[data-show-delivery-options]'),title=card.querySelector('.clore-quiz-sub-delivery-title'),body=card.querySelector('.clore-quiz-sub-delivery-body');
    if(!oldToggle||!title||!body)return;
    card.setAttribute('data-clore-frictionless-delivery','true');
    var toggle=oldToggle.cloneNode(true),options=document.createElement('div'),mode=/This date/.test(title.textContent)?'date':'april';
    body.innerHTML='First delivery: Ships today<br>Following delivery: '+(mode==='date'?'Ships on this date next year':'Ships first week of April each year');
    toggle.removeAttribute('data-show-delivery-options');
    toggle.setAttribute('data-clore-frictionless-delivery-toggle','true');
    oldToggle.replaceWith(toggle);
    options.className='space-y-1.5 pt-1 hidden';
    toggle.insertAdjacentElement('afterend',options);
    function updateForms(){
      var root=document.getElementById('clore-ember-kit-quiz'),plan=mode==='date'?'11642863851':'11642896619',label=mode==='date'?'Ships on this date next year':'Ships first week of April each year';
      root.querySelectorAll('[data-clore-quiz-cart-form]').forEach(function(form){
        var purchase=form.querySelector('input[name="properties[Purchase option]"]');
        if(!purchase||purchase.value.indexOf('Subscribe')<0)return;
        var planInput=form.querySelector('input[name="selling_plan"]'),deliveryInput=form.querySelector('input[name="properties[Annual delivery]"],input[name="properties[Following delivery]"]');
        if(planInput){planInput.disabled=false;planInput.value=plan;}
        if(deliveryInput){deliveryInput.name='properties[Following delivery]';deliveryInput.value=label;}
        if(!form.querySelector('input[name="properties[First delivery]"]')){
          var first=document.createElement('input');first.type='hidden';first.name='properties[First delivery]';first.value='Ships today';form.appendChild(first);
        }
      });
    }
    function renderOptions(){
      options.innerHTML=['april','date'].map(function(optionMode){var active=optionMode===mode,label=optionMode==='april'?'Ships first week of April each year':'Ships on this date each year';return '<button type="button" data-clore-frictionless-delivery-mode="'+optionMode+'" class="w-full flex items-center gap-2 rounded-lg border px-3 py-1.5 text-left transition-colors '+(active?'border-accent bg-accent/10':'border-silver-sage/50 bg-background hover:border-accent/50')+'"><span class="h-3.5 w-3.5 shrink-0 rounded-full border flex items-center justify-center '+(active?'border-accent':'border-slate-charcoal/40')+'">'+(active?'<span class="h-1.5 w-1.5 rounded-full bg-accent"></span>':'')+'</span><span class="clore-quiz-sub-delivery-option text-sm sm:text-base font-heading font-bold text-slate-charcoal leading-tight">'+label+'</span></button>';}).join('');
      options.querySelectorAll('[data-clore-frictionless-delivery-mode]').forEach(function(button){button.addEventListener('click',function(event){event.preventDefault();event.stopPropagation();preserveScroll(function(){mode=button.getAttribute('data-clore-frictionless-delivery-mode')||'april';title.textContent='Annual delivery: '+(mode==='date'?'This date each year':'Early April, early fire season');body.innerHTML='First delivery: Ships today<br>Following delivery: '+(mode==='date'?'Ships on this date next year':'Ships first week of April each year');updateForms();saveResultState({delivery:mode});renderOptions();options.classList.add('hidden');});button.blur();});});
    }
    renderOptions();
    updateForms();
    toggle.addEventListener('click',function(event){event.preventDefault();event.stopPropagation();preserveScroll(function(){options.classList.toggle('hidden');if(!options.classList.contains('hidden'))renderOptions();});toggle.blur();});
  }

  function ensureRecommendationPurchaseStyles(){
    if(document.getElementById('clore-recommendation-purchase-styles'))return;
    var style=document.createElement('style');
    style.id='clore-recommendation-purchase-styles';
    style.textContent=`
      #clore-ember-kit-quiz [data-clore-purchase-options="true"]{gap:0!important}
      #clore-ember-kit-quiz [data-clore-purchase-options="true"]>*+*{margin-top:20px!important}
      #clore-ember-kit-quiz .clore-quiz-subscription-card,
      #clore-ember-kit-quiz .clore-purchase-option-card{width:100%;border-radius:16px!important;border:1px solid hsl(var(--silver-sage));background:hsl(var(--card));overflow:hidden;transition:border-color .18s ease,background-color .18s ease;color:hsl(var(--foreground));text-align:left}
      #clore-ember-kit-quiz .clore-quiz-subscription-card,
      #clore-ember-kit-quiz .clore-quiz-subscription-card *,
      #clore-ember-kit-quiz .clore-purchase-option-card,
      #clore-ember-kit-quiz .clore-purchase-option-card *{font-family:"Montserrat",Inter,system-ui,sans-serif!important}
      #clore-ember-kit-quiz .clore-quiz-subscription-card{cursor:pointer}
      #clore-ember-kit-quiz .clore-purchase-option--selected{border-color:hsl(var(--accent))!important;background:hsl(var(--accent)/.05)!important}
      #clore-ember-kit-quiz .clore-purchase-option--unselected{border-color:hsl(var(--silver-sage))!important;background:hsl(var(--card))!important}
      #clore-ember-kit-quiz .clore-quiz-subscription-card>.w-full{gap:12px!important;padding:24px 14px 8px!important}
      #clore-ember-kit-quiz .clore-quiz-subscription-card>.w-full>span:first-child{display:flex!important;align-items:flex-start!important;gap:10px!important;min-width:0}
      #clore-ember-kit-quiz .clore-quiz-subscription-card>span.absolute{padding:2px 10px!important;border-bottom-right-radius:12px!important;font-size:10px!important}
      #clore-ember-kit-quiz .clore-purchase-radio{display:flex;align-items:center;justify-content:center;width:16px;height:16px;flex:0 0 16px;margin-top:3px;border:1px solid hsl(var(--foreground)/.4);border-radius:9999px}
      #clore-ember-kit-quiz .clore-purchase-radio.is-selected{border-color:hsl(var(--accent))}
      #clore-ember-kit-quiz .clore-purchase-radio.is-selected>span{width:8px;height:8px;border-radius:9999px;background:hsl(var(--accent))}
      #clore-ember-kit-quiz .clore-purchase-subscription-details{padding:0 14px 12px!important}
      #clore-ember-kit-quiz .clore-purchase-subscription-details>*+*{margin-top:12px!important}
      #clore-ember-kit-quiz .clore-purchase-subscription-details>.flex{gap:8px!important}
      #clore-ember-kit-quiz .clore-purchase-subscription-details>.flex>span:first-child{width:14px!important;height:14px!important;margin-top:3px!important}
      #clore-ember-kit-quiz .clore-product-gift-block{gap:12px!important;margin:12px 0 0!important;padding:10px!important;border:1px solid hsl(var(--silver-sage)/.6);border-radius:12px!important;background:#fff!important}
      #clore-ember-kit-quiz .clore-product-gift-block img{width:64px!important;height:56px!important;flex:0 0 64px!important;padding:4px!important;border-radius:8px!important}
      #clore-ember-kit-quiz .clore-purchase-option-card__header{display:flex;align-items:flex-start;justify-content:space-between;gap:12px;width:100%;padding:12px 14px;border:0;background:transparent;color:inherit;text-align:left;cursor:pointer}
      #clore-ember-kit-quiz .clore-purchase-option-card__lead{display:flex;align-items:flex-start;gap:10px}
      #clore-ember-kit-quiz .clore-purchase-option-card__title,
      #clore-ember-kit-quiz .clore-purchase-option-card__meta{display:block}
      #clore-ember-kit-quiz .clore-quiz-sub-title,
      #clore-ember-kit-quiz .clore-purchase-option-card__title{font-size:14px!important;font-weight:700;line-height:17.5px!important}
      #clore-ember-kit-quiz .clore-quiz-sub-meta,
      #clore-ember-kit-quiz .clore-purchase-option-card__meta{margin-top:2px;font-size:10px!important;font-weight:400;line-height:16px!important;letter-spacing:.04em!important;white-space:nowrap;color:hsl(var(--muted-foreground))}
      #clore-ember-kit-quiz .clore-quiz-sub-price,
      #clore-ember-kit-quiz .clore-purchase-option-card__price{font-size:16px!important;font-weight:700;line-height:20px!important}
      #clore-ember-kit-quiz .clore-purchase-option-card__details{padding:0 8px 10px}
      #clore-ember-kit-quiz .clore-purchase-option-card__details>*+*{margin-top:6px}
      #clore-ember-kit-quiz .clore-purchase-sprayer-option{display:flex;align-items:flex-start;width:100%;padding:6px;border:1px solid hsl(var(--silver-sage)/.6);border-radius:8px;background:hsl(var(--card)/.7);color:inherit;text-align:left;cursor:pointer;transition:border-color .18s ease,background-color .18s ease}
      #clore-ember-kit-quiz .clore-purchase-sprayer-option:hover{border-color:hsl(var(--accent)/.5)}
      #clore-ember-kit-quiz .clore-purchase-sprayer-option.is-selected{border-color:hsl(var(--accent));background:hsl(var(--accent)/.1)}
      #clore-ember-kit-quiz .clore-purchase-sprayer-option__lead{display:flex;align-items:flex-start;gap:6px;min-width:0}
      #clore-ember-kit-quiz .clore-purchase-sprayer-radio{display:flex;align-items:center;justify-content:center;width:12px;height:12px;flex:0 0 12px;margin-top:3px;border:1px solid hsl(var(--foreground)/.4);border-radius:9999px;background:transparent}
      #clore-ember-kit-quiz .clore-purchase-sprayer-radio.is-selected{border-color:hsl(var(--accent))}
      #clore-ember-kit-quiz .clore-purchase-sprayer-radio.is-selected>span{width:6px;height:6px;border-radius:9999px;background:hsl(var(--accent))}
      #clore-ember-kit-quiz .clore-purchase-sprayer-title{display:block;white-space:nowrap}
      #clore-ember-kit-quiz .clore-purchase-sprayer-title{font-size:12px;font-weight:700;line-height:17.5px}
      #clore-ember-kit-quiz .clore-quiz-sub-delivery-title{margin:0!important;font-size:12px!important;line-height:15px!important}
      #clore-ember-kit-quiz .clore-quiz-sub-delivery-body{margin:0!important;font-size:11px!important;line-height:15.125px!important}
      #clore-ember-kit-quiz .clore-quiz-sub-delivery-title+.clore-quiz-sub-delivery-body{margin-top:0!important}
      #clore-ember-kit-quiz .clore-quiz-sub-delivery-link{font-size:11px!important}
      #clore-ember-kit-quiz .clore-quiz-sub-delivery-option{font-size:11px!important;line-height:1.25!important}
      #clore-ember-kit-quiz .clore-quiz-gift-copy{margin:0!important;font-size:14px!important;line-height:17.5px!important}
      #clore-ember-kit-quiz .clore-quiz-gift-sub{margin-top:2px!important;font-size:11px!important;line-height:16px!important}
      #clore-ember-kit-quiz .clore-purchase-add-button{display:flex;align-items:center;justify-content:center;width:100%;height:48px;border:0;border-radius:9999px;background:hsl(var(--accent));color:hsl(var(--accent-foreground));font-family:"Montserrat",Inter,system-ui,sans-serif!important;font-size:11px;font-weight:700;line-height:1.5;letter-spacing:.08em;text-transform:uppercase}
      #clore-ember-kit-quiz .clore-purchase-add-button:hover{opacity:.9}
      #clore-ember-kit-quiz .clore-purchase-add-button svg{width:16px;height:16px;margin-left:8px}
      @media(max-width:639px){
        #clore-ember-kit-quiz [data-clore-purchase-options="true"]{width:calc(100% + 32px);margin-left:-16px}
        #clore-ember-kit-quiz .clore-quiz-subscription-card[data-clore-purchase-options="true"]{width:100%;margin-left:0}
      }
      @media(min-width:640px){
        #clore-ember-kit-quiz .clore-quiz-sub-title,
        #clore-ember-kit-quiz .clore-purchase-option-card__title,
        #clore-ember-kit-quiz .clore-quiz-gift-copy{font-size:16px!important}
        #clore-ember-kit-quiz .clore-purchase-sprayer-title{font-size:14px!important}
        #clore-ember-kit-quiz .clore-quiz-sub-meta,
        #clore-ember-kit-quiz .clore-purchase-option-card__meta,
        #clore-ember-kit-quiz .clore-purchase-sprayer-meta,
        #clore-ember-kit-quiz .clore-quiz-sub-delivery-body,
        #clore-ember-kit-quiz .clore-quiz-sub-delivery-link,
        #clore-ember-kit-quiz .clore-quiz-gift-sub{font-size:12px!important}
        #clore-ember-kit-quiz .clore-quiz-sub-delivery-title{font-size:14px!important}
        #clore-ember-kit-quiz .clore-purchase-add-button{font-size:12px}
        #clore-ember-kit-quiz .clore-purchase-option-card__details{padding-left:12px;padding-right:12px}
        #clore-ember-kit-quiz .clore-purchase-sprayer-option{padding:8px}
        #clore-ember-kit-quiz .clore-purchase-sprayer-option__lead{gap:8px}
        #clore-ember-kit-quiz .clore-purchase-sprayer-radio{width:14px;height:14px;flex-basis:14px}
      }
    `;
    document.head.appendChild(style);
  }

  function enhanceRecommendationPurchaseOptions(stage,kitCard){
    var subscriptionCard=stage.querySelector('.clore-quiz-subscription-card');
    if(!kitCard||!subscriptionCard||subscriptionCard.dataset.clorePurchaseOptions==='true')return;
    var purchaseStack=subscriptionCard.parentElement;
    var giftBlock=subscriptionCard.nextElementSibling;
    var subscriptionForm=giftBlock&&giftBlock.nextElementSibling;
    var oneTimeGrid=subscriptionForm&&subscriptionForm.nextElementSibling;
    var oneTimeForms=oneTimeGrid?Array.from(oneTimeGrid.querySelectorAll('form[data-clore-quiz-cart-form]')):[];
    var withSprayerForm=oneTimeForms[0];
    var withoutSprayerForm=oneTimeForms[1]||oneTimeForms[0];
    if(!purchaseStack||!giftBlock||!subscriptionForm||!subscriptionForm.matches('form[data-clore-quiz-cart-form]')||!withSprayerForm)return;
    subscriptionCard.dataset.clorePurchaseOptions='true';
    purchaseStack.dataset.clorePurchaseOptions='true';
    ensureRecommendationPurchaseStyles();

    var lead=subscriptionCard.querySelector(':scope > .w-full > span:first-child');
    if(lead){
      var radio=document.createElement('span');radio.className='clore-purchase-radio';radio.setAttribute('data-clore-purchase-radio','subscription');lead.insertBefore(radio,lead.firstChild);
      var title=lead.querySelector('.clore-quiz-sub-title'),leadMeta=lead.querySelector('.clore-quiz-sub-meta');
      if(title&&leadMeta){var copy=document.createElement('span');lead.insertBefore(copy,title);copy.appendChild(title);copy.appendChild(leadMeta);}
    }
    var meta=subscriptionCard.querySelector('.clore-quiz-sub-meta');
    if(meta)meta.textContent='Free shipping today - Cancel anytime';
    var subscriptionDetails=subscriptionCard.querySelector('.clore-quiz-sub-delivery-title');
    subscriptionDetails=subscriptionDetails&&subscriptionDetails.closest('.px-3\\.5');
    if(!subscriptionDetails)return;
    subscriptionDetails.classList.add('clore-purchase-subscription-details');
    giftBlock.classList.add('clore-product-gift-block');
    subscriptionDetails.appendChild(giftBlock);

    function priceFromForm(form){var button=form&&form.querySelector('button[type="submit"]'),match=(button?button.textContent:'').match(/\$[\d,]+(?:\.\d{2})?/);return match?match[0]:'';}
    function priceNumber(price){return Number(String(price).replace(/[^\d.]/g,''))||0;}
    var withSprayerPrice=priceFromForm(withSprayerForm),withoutSprayerPrice=priceFromForm(withoutSprayerForm);
    var sprayerValue=Math.max(0,priceNumber(withSprayerPrice)-priceNumber(withoutSprayerPrice));
    var giftTitle=giftBlock.querySelector('.clore-quiz-gift-copy');
    var sprayerName=giftTitle&&/Hand Sprayer/i.test(giftTitle.textContent)?'Hand Sprayer':'Backpack Sprayer';
    var oneTimeCard=document.createElement('div');
    oneTimeCard.className='clore-purchase-option-card clore-purchase-option-card--one-time';
    oneTimeCard.setAttribute('data-clore-purchase-option','one-time');
    oneTimeCard.innerHTML='<button type="button" class="clore-purchase-option-card__header"><span class="clore-purchase-option-card__lead"><span class="clore-purchase-radio" data-clore-purchase-radio="one-time"></span><span><span class="clore-purchase-option-card__title">One Time Purchase</span><span class="clore-purchase-option-card__meta">Single delivery</span></span></span><span class="clore-purchase-option-card__price">'+withSprayerPrice+'</span></button><div class="clore-purchase-option-card__details"><button type="button" class="clore-purchase-sprayer-option is-selected" data-clore-sprayer-choice="with"><span class="clore-purchase-sprayer-option__lead"><span class="clore-purchase-sprayer-radio is-selected"><span></span></span><span class="clore-purchase-sprayer-title">WITH '+sprayerName+' (+$'+sprayerValue+')</span></span></button><button type="button" class="clore-purchase-sprayer-option" data-clore-sprayer-choice="without"><span class="clore-purchase-sprayer-option__lead"><span class="clore-purchase-sprayer-radio"></span><span class="clore-purchase-sprayer-title">WITHOUT '+sprayerName+' (-$'+sprayerValue+')</span></span></button></div>';
    subscriptionCard.insertAdjacentElement('afterend',oneTimeCard);
    subscriptionForm.hidden=true;
    subscriptionForm.style.setProperty('display','none','important');
    oneTimeGrid.hidden=true;
    oneTimeGrid.style.setProperty('display','none','important');

    var addButton=document.createElement('button');
    addButton.type='button';addButton.className='clore-purchase-add-button';addButton.innerHTML='Add to Cart <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg>';
    oneTimeCard.insertAdjacentElement('afterend',addButton);
    var selectedForm=subscriptionForm;
    var oneTimeHeader=oneTimeCard.querySelector('.clore-purchase-option-card__header');
    var oneTimeDetails=oneTimeCard.querySelector('.clore-purchase-option-card__details');
    var sprayerChoices=Array.from(oneTimeCard.querySelectorAll('[data-clore-sprayer-choice]'));
    var oneTimePrice=oneTimeCard.querySelector('.clore-purchase-option-card__price');
    var withSprayerSelected=true;
    function selectSprayer(withSprayer){
      withSprayerSelected=withSprayer;
      oneTimePrice.textContent=withSprayer?withSprayerPrice:withoutSprayerPrice;
      sprayerChoices.forEach(function(choice){
        var active=(choice.getAttribute('data-clore-sprayer-choice')==='with')===withSprayer;
        var radio=choice.querySelector('.clore-purchase-sprayer-radio');
        choice.classList.toggle('is-selected',active);
        radio.classList.toggle('is-selected',active);
        radio.innerHTML=active?'<span></span>':'';
      });
    }
    function select(option){
      var subscriptionSelected=option==='subscription';
      selectedForm=subscriptionSelected?subscriptionForm:(withSprayerSelected?withSprayerForm:withoutSprayerForm);
      subscriptionCard.classList.toggle('clore-purchase-option--selected',subscriptionSelected);
      subscriptionCard.classList.toggle('clore-purchase-option--unselected',!subscriptionSelected);
      oneTimeCard.classList.toggle('clore-purchase-option--selected',!subscriptionSelected);
      oneTimeCard.classList.toggle('clore-purchase-option--unselected',subscriptionSelected);
      subscriptionDetails.hidden=!subscriptionSelected;
      oneTimeDetails.hidden=subscriptionSelected;
      purchaseStack.querySelectorAll('[data-clore-purchase-radio]').forEach(function(radio){var active=radio.getAttribute('data-clore-purchase-radio')===option;radio.classList.toggle('is-selected',active);radio.innerHTML=active?'<span></span>':'';});
    }
    subscriptionCard.addEventListener('click',function(){preserveScroll(function(){select('subscription');});});
    subscriptionCard.setAttribute('tabindex','0');
    subscriptionCard.setAttribute('role','button');
    subscriptionCard.addEventListener('keydown',function(event){if(event.key==='Enter'||event.key===' '){event.preventDefault();preserveScroll(function(){select('subscription');});}});
    oneTimeHeader.addEventListener('click',function(){preserveScroll(function(){selectSprayer(true);select('one-time');});});
    sprayerChoices.forEach(function(choice){choice.addEventListener('click',function(event){event.stopPropagation();preserveScroll(function(){selectSprayer(choice.getAttribute('data-clore-sprayer-choice')==='with');select('one-time');});});});
    addButton.addEventListener('click',function(){if(typeof selectedForm.requestSubmit==='function')selectedForm.requestSubmit();else selectedForm.dispatchEvent(new Event('submit',{bubbles:true,cancelable:true}));});
    selectSprayer(true);
    select('subscription');
  }

  function init(){
    alignDefendHeroHeadline();
    window.addEventListener('resize',alignDefendHeroHeadline,{passive:true});
    var params=new URLSearchParams(window.location.search||'');
    if(params.get('viewDefendPage')==='1'){
      params.delete('viewDefendPage');
      history.replaceState(history.state,'',window.location.pathname+(params.toString()?'?'+params.toString():'')+window.location.hash);
      var quiz=document.getElementById('clore-ember-kit-quiz');
      if(quiz){quiz.hidden=true;quiz.setAttribute('aria-hidden','true');}
      document.documentElement.classList.remove('clore-kit-quiz-open');
    }
    var stage=document.querySelector('#clore-ember-kit-quiz [data-clore-kit-quiz-stage]');
    if(!stage)return;
    var quizRoot=document.getElementById('clore-ember-kit-quiz');
    if(quizRoot)quizRoot.style.overflowAnchor='none';
    stage.style.overflowAnchor='none';
    new MutationObserver(enhance).observe(stage,{childList:true,subtree:true});
    enhance();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
